import { useContext } from "react";

import { StandardMeetingsPanelContext } from "./StandardMeetingsPanelContext";

export function useStandardMeetingsPanel() {
  const context = useContext(StandardMeetingsPanelContext);
  if (!context) {
    throw new Error("useStandardMeetingsPanel must be used within a StandardMeetingsPanelProvider");
  }
  return context;
}
